import { render, staticRenderFns } from "./SummonHome.vue?vue&type=template&id=52902674&"
import script from "./SummonHome.vue?vue&type=script&lang=ts&"
export * from "./SummonHome.vue?vue&type=script&lang=ts&"
import style0 from "./SummonHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports